import React, { Component } from 'react';
import Grid from './Grid';

class LeadTheWay extends Component {

  render() {
    return (
      <section id="lead-the-way-section">
        <div className="container">
          <div className="row influencer-flex">
            <div className="copy-col">
              <h2>Lead The Way.</h2>
              <h4>Everybody’s <strong><em>not</em></strong> doing it—and that’s a fact.</h4>
              <p>Did you know that most Maine middle schoolers and high schoolers <strong><em>do not</em></strong> use and <strong><em>have never</em></strong> tried drugs? You can lead the way and be a positive influence by knowing the facts about drugs and alcohol so you can make smart decisions.</p>
              <p>Your life may be filled with pressure, some good, some bad. It’s important to be aware of the negative influences around you - whether that’s friends, school, athletics, social media, or something in the media. You have an opportunity to change the conversation and lead the way.</p>
            </div>
            <div className="grid-col">
              <Grid />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default LeadTheWay;



// WEBPACK FOOTER //
// ./src/components/LeadTheWay/LeadTheWay.js